import { PageNotFoundGuard } from './shared/guards/page-not-found-guard.service';
import { PagenotfoundComponent } from './layout/pagenotfound/pagenotfound.component';
import { ExternalLoginComponent } from './login/external-login/external-login.component';
import { Routes, RouterModule } from '@angular/router';
import { DevLoginComponent } from './login/dev-login/dev-login.component';
import { LoginComponent } from './login/login/login.component';
import { StagingLoginComponent } from './login/staging-login/staging-login.component';
import { LoginGuard } from './shared/guards/login-guard.service';
import { NgModule } from '@angular/core';
import { ClientidLoginComponent } from './login/clientid-login/clientid-login.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'claim-status/claims',
    pathMatch: 'full',
  },

  { path: 'login',
    component: LoginComponent,
    data: { breadcrumbTitle: 'Login' }
  },

  {
    path: 'new-claim',
    loadChildren: () => import('./features/new-claim-wizard/new-claim-wizard.module').then(m => m.NewClaimWizardModule),
    data: { breadcrumbTitle: 'New Claim', breadcrumbCssIcon: 'icon icon-plus-1'},
    canLoad: [ LoginGuard ]
  },

  {
    path: 'new-thirdparty-claim',
    loadChildren: () => import('./features/new-thirdparty-wizard/new-thirdparty-wizard.module').then(m => m.NewThirdpartyWizardModule),
    data: { breadcrumbTitle: 'New Thirdparty Claim', breadcrumbCssIcon: 'icon icon-plus-1'},
    canLoad: [ LoginGuard ]
  },
  {
    path: 'claim-status',
    loadChildren: () => import('./features/claim-status/claim-status.module').then(m => m.ClaimStatusModule),
    data: { breadcrumbTitle: 'Claims', breadcrumbCssIcon: 'icon icon-folder-open'},
    canLoad: [ LoginGuard ]
  },

  {
    path: 'history',
    loadChildren: () => import('./features/statement-history/statement-history.module').then(m => m.StatementHistoryModule),
    data: { breadcrumbTitle: 'History', breadcrumbCssIcon: 'icon icon-history'},
    canLoad: [ LoginGuard ]
  },

  {
    path: 'statement-history',
    loadChildren: () => import('./features/statement-history/statement-history.module').then(m => m.StatementHistoryModule),
    data: { breadcrumbTitle: 'Statement History', breadcrumbCssIcon: 'icon icon-history'},
    canLoad: [ LoginGuard ]
  },
  {
    path: 'claim-detail',
    loadChildren: () => import('./features/claim-detail/claim-detail.module').then(m => m.ClaimDetailModule),
    data: { breadcrumbTitle: 'Claim Detail', breadcrumbCssIcon: 'icon icon-history'},
    canLoad: [ LoginGuard ]
  },
  {
    path: 'claim-resubmit',
    loadChildren: () => import('./features/claim-resubmit/claim-resubmit.module').then(m => m.ClaimResubmitModule),
    data: { breadcrumbTitle: 'Claim Resubmit', breadcrumbCssIcon: 'icon icon-plus-1'},
    canLoad: [ LoginGuard ]
  },
  {
    path: 'quote-detail',
    loadChildren: () => import('./features/quote-detail/quote-detail.module').then(m => m.QuoteDetailModule),
    data: { breadcrumbTitle: 'Quote Detail', breadcrumbCssIcon: 'icon icon-history'},
    canLoad: [ LoginGuard ]
  },
  {
    path: 'search-part',
    loadChildren: () => import('./features/search-discount/search-discount.module').then(m => m.SearchDiscountModule),
    data: { breadcrumbTitle: 'Part Search', breadcrumbCssIcon: 'icon icon-search'},
    canLoad: [ LoginGuard ]
  },
  {
    path: 'external-login',
    component: ExternalLoginComponent
  },
  {
    path: 'clientid-login',
    component: ClientidLoginComponent,
    data: { breadcrumbTitle: 'Login' }
  },
  { path: 'page-not-found', component: PagenotfoundComponent},
  {
    path: 'dev-login', component: DevLoginComponent,
    data: { breadcrumbTitle: 'Development Login', breadcrumbCssIcon: 'icon-activity-2' }
  },
  {
    path: 'staging-login', component: StagingLoginComponent,
    data: { breadcrumbTitle: 'Staging Login', breadcrumbCssIcon: 'icon-activity-2' }
  },
  { path: '**', component: PagenotfoundComponent, canActivate: [PageNotFoundGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor() {

  }
}
